export enum Ownership {
  YES = 'YES',
  CO_OWNER = 'CO_OWNER',
  RELATIVE = 'RELATIVE',
  NO = 'NO',
}
